import { createHttpInstance } from '~/common/utils/http';

const httpInstance = createHttpInstance('formalization');

export default httpInstance;
